module.exports = __webpack_public_path__ + "img/img-cart-empty.4160246c.svg";